import FluxoKamban from './FluxoKamban'
export default FluxoKamban


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/FluxoKamban/index.js